import React, { useState, useEffect, useRef } from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'

import { FormControl, InputLabel, Select, MenuItem } from '@material-ui/core'

export default function CoopProductClassSelector (props) {
  const [rightMap] = useState(new Map(props.rights.map((right) => [right.id, right])))
  const [proClsMap] = useState(new Map(props.productClasses.map((proCls) => [proCls.id, proCls.name])))
  const [proClsOptions, setProClsOptions] = useState([])
  const [rightDiv, setRightDiv] = useState(null) // right_id, coop_div_flgの値の組
  const rightDivRef = useRef(null)
  rightDivRef.current = rightDiv
  const [pro, setPro] = useState('init') // 'init'は初期状態を表し、useEffect内の最初の実行で直ちに書き換わる

  useEffect(() => {
    const elRightId = $('input[name="right_id"]')
    if (!elRightId.length) {
      console.error('#coop-product-class-selecterを使用する場合はinput[name="right_id"]要素を設置してください。')
    }
    elRightId.on('change', (e) => {
      setRightDiv([rightMap.get(e.target.value) ?? null, rightDivRef.current[1]])
    })

    const elCoopDivFlg = $('input[name="coop_div_flg"]')
    if (!elCoopDivFlg.length) {
      console.error('#coop-product-class-selecterを使用する場合はinput[name="coop_div_flg"]要素を設置してください。')
    }
    elCoopDivFlg.on('change', (e) => {
      setRightDiv([rightDivRef.current[0], e.target.value])
    })

    setRightDiv([rightMap.get(elRightId.val()) ?? null, elCoopDivFlg.val()])
  }, [])

  useEffect(() => {
    if (!rightDiv) {
      return
    }
    const [right, div] = rightDiv
    // right, divに基づいて商品区分のoptionsを変更する
    let _options = null
    if (!proClsMap || !right) {
      _options = []
    } else if (div === '1') {
      // 分配分->mst_rights.mst_product_class_id
      _options = [right.mst_product_class_id]
    } else {
      // 不要分・その他->mst_rights.product_classes
      _options = right.product_classes
    }
    setProClsOptions(_options)

    // right, divが変更されたらproはリセット
    // pro='init'のとき（最初の実行時）は初期値をセットする
    if (pro === 'init') {
      const initValue = props.value.toString()
      setPro(proClsMap.has(initValue) ? initValue : (_options.length > 0 ? _options[0] : 'null'))
    } else {
      setPro(div === '1' ? (_options.length > 0 ? _options[0] : 'null') : 'null')
    }
  }, [rightDiv])

  return (
    <div className="my-input-root">
      <FormControl className='my-input-root w-100' required>
        <InputLabel>商品区分</InputLabel>
        <Select
          name='coop_pro_cls'
          value={pro}
          className={'w-100'}
          onChange={(e) => {
            setPro(e.target.value)
          }}
          disabled={props.readonly}
          inputProps={{
            disabled: props.readonly
          }}>
          <MenuItem key='null' value='null'>（未選択）</MenuItem>
          {proClsOptions.sort().map((id, i) => {
            return (
              <MenuItem key={id} value={id}>{`${id}: ${proClsMap.get(id)}`}</MenuItem>
            )
          })}
          {pro === 'init' && (
            <MenuItem key='init' value='init'>init</MenuItem> // pro='init'でエラーを出さないためのダミーオプション
          )}
          {pro !== 'init' && pro !== 'null' && !proClsOptions.find((id) => id === pro) && (
            <MenuItem key={pro} value={pro}>{`${pro}: ${proClsMap.get(pro)}`}</MenuItem> // proの初期値がoptionsに無い場合にエラーを出さないためのオプション
          )}
        </Select>
      </FormControl>
    </div>
  )
}

CoopProductClassSelector.propTypes = {
  rights: PropTypes.arrayOf(PropTypes.object),
  productClasses: PropTypes.arrayOf(PropTypes.object),
  value: PropTypes.number,
  readonly: PropTypes.bool,
  characterId: PropTypes.number
}

CoopProductClassSelector.defaultProps = {
  characterId: 0
}

$('#coop_product_class_selector').each((i, elem) => {
  const props = $(elem).data() // bladeでdata-xxxx形式で指定した値がpropsとして参照できる
  ReactDOM.render(<CoopProductClassSelector {...props}/>, elem)

  Object.keys(props).map((key) => { // ソースにdata-属性が残らないように削除
    $(elem).removeAttr('data-' + key.replace(/[A-Z]/g, (s) => '-' + s.charAt(0).toLowerCase()))
    return 0
  })
})
